module.exports = __webpack_public_path__ + "assets/d113ead66815f378bd836dcaee24e785.png";